<template>
    <div class="bg-white container">
        <div class="row">
            <q-checkbox
                class="q-mr-sm"
                color="primary"
                dense
                :value="isSelectAll"
                @input="onChangeSelectAll"
            />
            <div class="title text-black">Select all</div>
        </div>
        <q-separator />
        <div class="row text-black justify-end">
            <div class="col-12 col-md-6">
                <div class="row justify-between items-baseline">
                    <div class="text-subtitle2">Sub total</div>
                    <div class="text-primary">
                        {{ subTotal | formattedPrice }}
                    </div>
                </div>
                <div class="row justify-between items-baseline">
                    <div class="text-subtitle2">Promotional discount</div>
                    <div class="text-red">
                        {{ discountTotal | formattedPrice | nagativeNumber }}
                    </div>
                </div>
                <div class="row justify-between items-baseline">
                    <div class="text-h6">Total</div>
                    <div class="text-primary text-h6 text-bold">
                        {{ grandTotal | formattedPrice }}
                    </div>
                </div>
            </div>
        </div>
        <q-btn
            dense
            :loading="loading"
            class="full-width"
            color="primary"
            label="Checkout"
            @click="onCheckout"
        >
            <template slot="loading">
                <q-spinner-dots color="white" size="1em" />
            </template>
        </q-btn>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
    name: "CartFooter",
    computed: {
        ...mapGetters({
            isSelectAll: "cartData/isSelectAll",
        }),
        ...mapState({
            subTotal: (state) => state.cartData.subTotal,
            discountTotal: (state) => state.cartData.discountTotal,
            grandTotal: (state) => state.cartData.grandTotal,
            loading: (state) => state.cartData.loading,
        }),
    },
    methods: {
        onChangeSelectAll(value) {
            this.$store.commit("cartData/setSelectAll", value);
            this.$store.dispatch("cartData/getCost");
        },
        async onCheckout() {
            const productList = this.$store.getters["cartData/selectedProducts"];
            await this.$store.dispatch("checkout/computeScheduleGroup", productList);
            this.$router.push({
                name: "Checkout",
            });
        },
    },
};
</script>

<style scoped>
.container {
    padding: 10px !important;
}
</style>
